import { useQuery } from '@tanstack/react-query';
import { IListResponse } from '../../interfaces/listResponse';
import { IClientAdminSearch } from '../../interfaces/clientAdminSearch';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { ClientService } from '../../services/client';
import { parseAxiosError } from '../../services/axios';
import { CLIENT_LIST_QUERY_KEY } from '../../components/clients/Clients';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IClientAdminSearchParams } from '../../interfaces/clientAdminSearchParams';
import { useNotification } from '../../+state/useNotification';

interface IProps extends IBaseUseQueryProps<IListResponse<IClientAdminSearch>> {
  search: IClientAdminSearchParams,
}

export const useGetClientsList = ({ search, onError, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [CLIENT_LIST_QUERY_KEY, search],
    queryFn: () => ClientService.getList(search),
    refetchOnWindowFocus: true,
    keepPreviousData: true,
    retry: false,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      onError?.(err);
    },
    ...props
  });
};